import {action, observable, runInAction, toJS} from "mobx";
import {customEvent} from "../../../../utils/analyticsUtil";
import {actions, category, events} from "../../../../constants/enums";
import manageStore from "../../../../stores/ManageStore"
import appStore from "../../../app/store";


class AttachStudentStore {
    @observable isAssignDialogOpen = false;
    @observable teacher;
    @observable selectedStudentList = [];
    @observable hasChanges = false;
    @observable titleKey = '';

    @action onToggleAssignDialog = (teacher) => {
        this.isAssignDialogOpen = !this.isAssignDialogOpen;
        this.titleKey = (teacher?.students && teacher.students.length > 0) ? 'manage.assign.manage.students' : 'manage.assign.students';

        this.assignedStudentList = [];
        this.unassignedStudentsList = [];
        this.hasChanges = false;
        this.teacher = null;
        if (this.isAssignDialogOpen) {
            this.teacher = teacher;

            const studentMap = (this.teacher.students || []).reduce((res, studentId) => {
                res[studentId] = true;
                return res;
            }, {});

            this.selectedStudentList = manageStore.enrichedStudentList
                .map(s => ({...s, selected: studentMap[s.id], preSelected: studentMap[s.id]}));
        }
    };

    @action toggleSelected = (student) => {
        student.selected = !student.selected;
        this.hasChanges = true;
    }

    @action onAssignSave = async () => {
        this.submitted = true;
        let teacher = this.teacher;
        const selectedStudentsList = toJS(this.selectedStudentList);
        this.onToggleAssignDialog();
        try {
            customEvent(events.CustomEvent, {
                category: category.SchoolAdmin,
                action: actions.AssignSave,
                label: {numStudents: this.selectedStudentList.filter(student => student.selected).length}
            });
            await manageStore.sendAttachedStudents(teacher.id, selectedStudentsList.filter(student => student.selected).map(student => student.id));
            appStore.createAlertFromMessageId('success', 'manage.attach.student.success');
        } catch (err) {
            console.log('error assigning user: ' + err);
            appStore.createAlertFromMessageId('error', 'manage.assign.error');
        } finally {
            runInAction(() => {
                this.submitted = false;
            });
        }
    }

}


const attachStudentStore = new AttachStudentStore();
export default attachStudentStore;
